import React from 'react'
import {SidePanel} from './components/SidePanel'
import {CurrentConversationView} from './components/CurrentConversationView'
import {Provider, useDispatch, useSelector} from "react-redux";
import {fetchConversations} from './actions/conversations/fetchConversations';
import {store} from './store'
import {setCurrentConversation} from './actions/currentConversation/setCurrentConversation';
import {fetchCurrentConversationMessages} from './actions/currentConversation/fetchCurrentConversationMessages';
import {FabButton} from "./components/FabButton";
import {closeSidePanelPopOver} from "./dux/ui/actions";

export const Messages = (props) => (
  <Provider store={store(props)}>
    <Root/>
  </Provider>
)

const Root = () => {
  const dispatch = useDispatch()
  const {conversations, currentConversation, recipients} = useSelector(state => state)
  const handleSetCurrentConversation = (conversation) => {
    dispatch(closeSidePanelPopOver());
    dispatch(setCurrentConversation(conversation))
  }
  const handleFetchConversations = (shouldSetCurrentConversation, showLoading) => dispatch(fetchConversations(shouldSetCurrentConversation, showLoading))
  const handleFetchCurrentConversation = (conversation) => dispatch(fetchCurrentConversationMessages(conversation))
  const innerWidth = window.innerWidth

  React.useEffect(() => {
    const ws = App.cable.subscriptions.create("ChatChannel", {
      received: (data) => {
        handleFetchConversations(false, false)
      }
    })
  }, [])

  React.useEffect(() => {
    async function fetchConvos() {
      const response = await handleFetchConversations(true)
    }

    fetchConvos()
  }, [])


  React.useEffect(() => {
    if (currentConversation.id) handleFetchCurrentConversation(currentConversation)
  }, [currentConversation.id])

  const {visible} = useSelector(state => state.ui.sidePanelPopOver)

  return (
    <div className="messages">
      <SidePanel
        recipients={recipients}
        onSetCurrentConversation={handleSetCurrentConversation}
        currentConversation={currentConversation}
        conversations={conversations.conversations}
        loadingMoreConversations={conversations.loadingMoreConversations}
        canLoadMoreConversations={conversations.canLoadMoreConversations}
        loading={conversations.loading}
        popoverVisible={true}/>
      {!visible &&
        <div className="w-100 h-100 border d-flex bg-white">
          {innerWidth > 1000 && <SidePanel
            recipients={recipients}
            onSetCurrentConversation={handleSetCurrentConversation}
            currentConversation={currentConversation}
            conversations={conversations.conversations}
            loadingMoreConversations={conversations.loadingMoreConversations}
            canLoadMoreConversations={conversations.canLoadMoreConversations}
            loading={conversations.loading}/>}
          <div style={{width: innerWidth > 1450 ? 'calc(100% - 230px)' : '100%'}}>
            <CurrentConversationView currentConversation={currentConversation}/>
          </div>
        </div>}
    </div>
  )
}


export default Messages
